/**
 * Marker prefix on erpPostingError when the last posting attempt's outcome is
 * unknown — the ERP may already hold it, so the transaction must not be
 * re-posted without the user checking (SEE-1259). Written by the Agave posting
 * processor (Sage 300) and by the direct-QBO posting service after a browser-side
 * timeout (SEE-1763); read by isUnconfirmedPostingError in app/services/agave/erpUtils.
 *
 * Lives in util/ so both the Agave and the ErpConnection posting modules can
 * share it without either importing the other.
 */
export const UNCONFIRMED_POSTING_PREFIX = '[UNCONFIRMED]';

/**
 * Prefix on erpPostingWarning while a Sage 300 posting is still PENDING because
 * hh2's agent cannot import it into Sage and is retrying (SEE-1861; Richardson's
 * "Replacement length" macro error). Written by speedchain-cdk erp-post-confirm
 * (SAGE300_IMPORT_RETRY_WARNING_PREFIX) and cleared there when the posting
 * completes or fails — keep the two in step. Drives the "Sage import error"
 * status label and the side-panel banner.
 */
export const SAGE300_IMPORT_RETRY_WARNING_PREFIX = "Sage 300 hasn't accepted this posting yet";
